module.exports = __webpack_public_path__ + "img/no-SLA.71c5c9bd.svg";